import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=615c5034"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615c5034')) {
      api.createRecord('615c5034', component.options)
    } else {
      api.reload('615c5034', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=615c5034", function () {
      api.rerender('615c5034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Tab.vue"
export default component.exports